<template>
    <div class="Footer">
        <div class="footer-top">
            <div class="left">
  
                <div class="content">
                    <img src="../assets/foot_logo.png"/>
                    <p><span>苏州弘瀚自动化科技有限公司</span></p>
                    <p>电话: 0512-68321638</p>
                    <p>邮箱: sales@sz-falcon.com</p>
                    <p>地址: 苏州高新区和枫产业园 37号</p>
                </div>
        
            </div>

            <div class="right">
                <ul class="out">
                    <li v-for="(item,index) in footerList" :key="index">
                        <p><router-link :to="item.path">{{item.name}}</router-link></p>
                        <ul class="inside">
                            <li v-for="(items, indexs) in item.children" :key="indexs">
                                <router-link :to="{path: items.path, query: {tabid: indexs}}" tag="div">
                                    {{items.name}}
                                </router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <div class="footer-bottom">
            <a href="https://beian.miit.gov.cn" target="_blank"><p>Copyright © 版权所有 苏州弘瀚自动化科技有限公司 苏ICP备19026559号-1</p></a>
        </div>
    </div>
    
</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: String
  },
  data(){
      return{
          
        footerList: [
            {
                id: '0',
                name: "首页",
                path: "/",
                children: [
                    {
                        id: "1-1",
                        name: "企业简介",
                        path: "/About",
                        active: true,
                    },
                    {
                        id: "1-2",
                        name: "产品中心",
                        path: "/Product",
                        active: true,
                    },
                    {
                        id: "1-3",
                        name: "专案展示",
                        path: "/IndustryCase",
                        active: true,
                    },
                    {
                        id: "1-4",
                        name: "行业动态",
                        path: "/News",
                        active: true,
                    },
                ], 
            },
            {
                id: '1',
                name: "关于弘瀚",
                path: "/About" ,
                children: [
                    {
                        id: "1-1",
                        name: "公司简介",
                        path: "/About",
                        active: true,
                    },
                    {
                        id: "1-2",
                        name: "公司荣誉",
                        path: "/About",
                        active: true,
                    },
                    // {
                    //     id: "1-3",
                    //     name: "企业文化",
                    //     path: "/About",
                    //     active: true,
                    // },
                    {
                        id: "1-3",
                        name: "发展历程",
                        path: "/About",
                        active: true,
                    },
                ],
            },
            {
                id: '1',
                name: "产品中心",
                path: "/Product" ,
            },
            {
                id: '1',
                name: "行业案例",
                path: "/IndustryCase" ,
            },
            {
                id: '1',
                name: "行业动态",
                path: "/News" ,
                children: [
                    {
                        id: "1-1",
                        name: "新闻中心",
                        path: "/News",
                        active: true,
                    }
                ],
            },
            {
                id: '1',
                name: "联系我们",
                path: "/ContactUs" ,
                children: [
                    {
                        id: "1-1",
                        name: "联系方式",
                        path: "/ContactUs",
                        active: true,
                    },
                    {
                        id: "1-1",
                        name: "在线地图",
                        path: "/ContactUs",
                        active: true,
                    }
                ],
            }
          ]
      }
  }
}
</script>

<style scoped>
.Footer{
    margin-top: 200px;
    background-image: url(../assets/foot_img.png);
}

.footer-top{
    display: flex;
    justify-content: space-between;
    width: 66.66%;
    height: 420px;
    margin: 0 auto;
}

.footer-bottom{
    height: 40px;
    background-color: #323F4F;
}

.footer-bottom p{
    margin: 0;
    text-align: center;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    line-height: 40px;
    color: #999999;
}

.Footer .left{
    width: 30%;
    height: 280px;
    box-sizing: border-box;
    margin-top: 80px;
    padding-right: 30px;
}

.Footer .left .content img{
    width: 120px;
    height: 120px;
}

.Footer .left .content p{
    font-size: 12px;
    font-family: MicrosoftYaHei;
    line-height: 24px;
    color: #FFFFFF;
}

.Footer .left .content p span{
    display: block;
    margin-bottom: 20px;
    text-align: left;
    font-size: 15px;
    font-family: MicrosoftYaHei;
    line-height: 24px;
    color: #FFC200;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}

.Footer .right{
    margin-top: 80px;
    padding-left: 7.5%;
    box-sizing: border-box;
    width: 70%;
    height: 280px;
    /* border: 1px solid red; */
    border-left: 1px dashed #ddd;
}

.Footer .right ul{
    list-style: none;
}

.Footer .right .out{
    display: flex;
    margin: 0;
}

.Footer .right .out > li{
    width: 145px;
}

.Footer .right .out > li > p{
    margin-bottom: 20px;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    line-height: 24px;
    color: #FFC200;
}

.Footer .right .out > li > p > a{
    text-decoration: none;
    color: #FFC200;
}

.Footer .right .out > li > .inside{
    padding: 0;
    text-align: left;
}

.Footer .right .out > li > .inside > li{
    margin-bottom: 10px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    line-height: 24px;
    color: #FFFFFF;
}

.Footer .right .out > li > .inside > li a{
    text-decoration: none;
    color: #fff;
}

.Footer .right .out > li > .inside > li div:hover{
    cursor:pointer;
    color: #FFC200;
}

.footer-bottom a{
    text-decoration:none;
}

/* .inside */
</style>








// WEBPACK FOOTER //
// src/components/Footer.vue